var _polygon, _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTrainingAndDevelopmentSvgBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon_Training_and_Development_Black") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "449.85 85.91 179.4 85.91 179.4 131.62 204.4 131.62 204.4 110.91 424.85 110.91 424.85 272.18 204.4 272.18 204.52 248.6 179.52 248.47 179.26 297.18 250.1 297.18 212.5 410.32 236.22 418.2 276.38 297.36 275.83 297.18 301.19 297.18 301.19 393.79 326.19 393.79 326.19 297.18 350.73 297.18 390.84 417.87 414.56 409.98 377.07 297.18 449.85 297.18 449.85 85.91"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.26,119.15A37.94,37.94,0,1,0,75.33,81.21,38,38,0,0,0,113.26,119.15Zm0-50.87a12.94,12.94,0,1,1-12.93,12.93A12.95,12.95,0,0,1,113.26,68.28Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M150.55,151.81l34.33,71,79.65,0v-25h-64L172.15,139l-.5-.73a26.31,26.31,0,0,0-2.34-3A31.07,31.07,0,0,0,146,125.05H80.52c-16.75,0-30.37,12.87-30.37,28.69V297.23h25V153.74c0-2,2.46-3.69,5.37-3.69H146A6.19,6.19,0,0,1,150.55,151.81Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 335.63,
    y: 136.16,
    width: 25,
    height: 110.97
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 374.15,
    y: 199.73,
    width: 25,
    height: 47.4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 297.45,
    y: 172.52,
    width: 25,
    height: 74.61
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 125.94,
    y: 272.46,
    width: 25,
    height: 171.57
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 87.93,
    y: 272.46,
    width: 25,
    height: 171.76
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrainingAndDevelopmentSvgBlack);
export default __webpack_public_path__ + "static/media/Icon_Training_and_Development_SVG_Black.2cc1efa27fad1b160d1e9ba86e777d7c.svg";
export { ForwardRef as ReactComponent };